import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=49749a7c&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=49749a7c&lang=scss&scoped=true&"
import style1 from "./RegistrationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49749a7c",
  null
  
)

export default component.exports